import { configureStore } from '@reduxjs/toolkit';
import popReducer from '../slices/popSlice';
import userReducer from '../slices/userSlice';
import urlReducer from '../slices/urlSlice';
import notificationReducer from '../slices/notificationSlice';
import newsReducer from '../slices/newsSlice';

export const store = configureStore({
    reducer: {
        pop: popReducer,
        user: userReducer,
        url: urlReducer,
        notification: notificationReducer,
        news: newsReducer,
    },
});
